import { render, staticRenderFns } from "./columnsheader.vue?vue&type=template&id=50dc9ec9"
import script from "./columnsheader.vue?vue&type=script&lang=js"
export * from "./columnsheader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports